// extracted by mini-css-extract-plugin
export var Container = "style-module--Container--3AX8F";
export var Inline_Container = "style-module--Inline_Container--y3i5H";
export var Loader = "style-module--Loader--DDzng";
export var Loading = "style-module--Loading--C77fk";
export var Page_Container = "style-module--Page_Container--0EYD9";
export var pageLoadingScale = "style-module--pageLoading-scale--AHh4f";